export default __webpack_public_path__ + "static/media/Union.19ece873.svg";